export const INIT_AI_INTERVIEW_INVITES = "INIT_AI_INTERVIEW_INVITES";
export const SCHEDULE_AI_INTERVIEW_INVITE = "SCHEDULE_AI_INTERVIEW_INVITE";

export const AI_INTERVIEW_INVITES = "AI_INTERVIEW_INVITES";
export const PERSON_INTERVIEW_INVITES = "PERSON_INTERVIEW_INVITES";
export const AI_INTERVIEW_INVITE_BY_ID = "AI_INTERVIEW_INVITE_BY_ID";

